import axios from "axios";
import { GET_LANGUAGES } from "../actions";
const PROXY = process.env.REACT_APP_URL + "api/";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getLanguages = () => async (dispatch) => {
  const res = await axios.get(PROXY + "label/get-language");
  dispatch({
    type: GET_LANGUAGES,
    payload: res.data.result,
  });
  return res;
};

export const addLanguage = (obj) => async (dispatch) => {
  const body = JSON.stringify(obj);
  const res = await axios.post(PROXY + "label/add-language", body, config);
  return res;
};

export const updateLanguage = (id, language) => async (dispatch) => {
  const body = JSON.stringify(language);

  return await axios.patch(PROXY + "label/update-language/" + id, body, config);
};

export const deleteLanguage = (_id) => async (dispatch) => {
  return await axios.delete(PROXY + "label/delete-language/" + _id);
};
export const changeLanguageStatus = (id, language) => async (dispatch) => {
  const body = JSON.stringify(language);

  return await axios.put(PROXY + "label/change-status/" + id, body, config);
};
